
// Client-side config: This is *public* and imported from the frontend

export const googleMapsApiKey = 'AIzaSyD_0SsUp7tGsdnPl_BEK_Y_YoXskMhXqHU'

export const azureConfig = {
  clientId: '127abd52-127b-4873-b520-fcf8d9fa8c82',
  authority: 'https://gecopvautaadb2cpvca001.b2clogin.com/gecopvautaadb2cpvca001.onmicrosoft.com/B2C_1A_B2C_1_selfservice-prod-externalapp',
  knownAuthorities: ['gecopvautaadb2cpvca001.b2clogin.com'],
  b2cScopes: [
    'https://gecopvautaadb2cpvca001.onmicrosoft.com/selfservice-prod/read'
  ],
   instrumentKey:
  process.env.APPINSIGHTS_INSTRUMENTATIONKEY,
  redirectUri:
    process.env.AZURE_AUTH_REDIRECT_URL,
    tenantId:process.env.AZURE_TENANT_ID 
    // process.env.NODE_ENV==='development'
    //   ? `http://localhost:${process.env.PORT || 3000}`
    //   : 'https://standbymd.tangibletasks.com'
}

export const gaMeasurementID = 'G-WKX29RN0C8'
export const defaultOrganizationId = 'c76e70e5-54e4-47ba-b081-f3e8b4ae1570'
export const platformIdentifier = '9c8fcef6-849c-4788-8877-29929fa984bd'
export const defaultContextId = '7099e159-a0c3-4100-abba-f374ff41a3dc'
export const defaultCovidUrl = 'https://www.who.int/emergencies/diseases/novel-coronavirus-2019'
export const apiEndPointFromNode = 'https://geihpv-app-web-singular-api-ca-cn1-prod.azurewebsites.net/api/'
export const gemOrgId = 'c76e70e5-54e4-47ba-b081-f3e8b4ae1570'